module.exports = __webpack_public_path__ + "img/goodsC2.7d746122.png";